import { render } from "./ConfirmDialog.vue?vue&type=template&id=c0cabba0"
import script from "./ConfirmDialog.vue?vue&type=script&lang=js"
export * from "./ConfirmDialog.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__